import $http from "../../axios-instance";
import Swal from "sweetalert2";

/**
 * @description: Obtiene todos los banners
 */
export async function getBanners({ commit, state }, params) {
    commit("dashboard/load", true, { root: true });
    try {
        const res = await $http.get(
            "/app-banners/index?page=" +
                params.page +
                "&limit=" +
                params.limit +
                "&search=" +
                params.search +
                "&state=" +
                params.state
        );
        commit("setList", res.data.data);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * @description: Obtiene un banner por id.
 * @param {int} id
 */
export async function getBanner({ commit, state }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const res = await $http.get("/app-banners/show/" + id);
        commit("setBanner", res.data.data);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * @description: Actualiza un banner.
 *
 * @param {int} id
 * @param {object} data
 */
export async function updateBanner({ commit, state, dispatch }, data) {
    commit("dashboard/load", true, { root: true });
    try {
        data.is_active = data.is_active === true ? 1 : 0;
        data.is_date_end = data.is_date_end === true ? 1 : 0;
        let form = new FormData();
        form.append("title", data.title);
        form.append("is_active", data.is_active);
        form.append("date_init", data.date_init);
        form.append("is_date_end", data.is_date_end);
        form.append("interval", data.interval);
        if (data.order){
            form.append("order", data.order);
        }
        if (data.is_date_end) {
            form.append("date_end", data.date_end);
        } else {
            form.delete('date_end')
        }
        if (data.new_image) {
            form.append("image", data.new_image);
        }
        const res = await $http.post("/app-banners/update/" + data.id, form);
        commit("setBanner", res.data.data.data);
        commit("setShowModalForm", false);
        commit("dashboard/load", false, { root: true });
        Swal.fire({
            title: "Banner actualizado",
            text: "El banner se actualizó correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
        });
        return true;
    } catch (error) {
        commit("dashboard/load", false, { root: true });
        commit("setBanner", data);
        const responseData = error.errors;
        Object.keys(responseData).forEach((key) => {
            const errorMessage = responseData[key];
            if (errorMessage) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: errorMessage,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        });
        return false;
    }
}

/**
 * @description: Crea un banner.
 *
 * @param {object} data
 */
export async function createBanner({ commit, state }, data) {
    commit("dashboard/load", true, { root: true });
    try {
        data.is_active = data.is_active === true ? 1 : 0;
        data.is_date_end = data.is_date_end === true ? 1 : 0;
        let form = new FormData();
        form.append("title", data.title);
        form.append("is_active", data.is_active);
        form.append("interval", data.interval);
        form.append("image", data.new_image);
        form.append("date_init", data.date_init);
        form.append("is_date_end", data.is_date_end);
        form.append("order", data.order);
        if (data.is_date_end) {
            form.append("date_end", data.date_end);
        }
        await $http.post("/app-banners/create", form);
        commit("resetBanner");
        commit("setShowModalForm", false);
        commit("dashboard/load", false, { root: true });
        Swal.fire({
            title: "Banner creado",
            text: "El banner se creó correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
        });
        return true;
    } catch (error) {
        commit("dashboard/load", false, { root: true });
        const responseData = error.errors;
        Object.keys(responseData).forEach((key) => {
            const errorMessage = responseData[key];
            if (errorMessage) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: errorMessage,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        });
        return false;
    }
}

/**
 * @description: Desactiva un banner o activa un banner.
 *
 * @param {object} data
 */
export async function changeStateBanner({ commit, state, dispatch }, data) {
    await Swal.fire({
        title: data.is_active ? "¿Desactivar banner?" : "¿Activar banner?",
        text: data.is_active
            ? "El banner se desactivará"
            : "El banner se activará",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si",
    }).then(async (result) => {
        if (result.value) {
            data.is_active = !data.is_active;
            await dispatch("updateBanner", data);
            commit("resetBanner");
        }
    });
}

/**
 * Listar los banners activos.
 */
export async function getBannersActive({ commit, state }) {
    commit("dashboard/load", true, { root: true });
    try {
        const res = await $http.get("/app-banners/list-actives");
        commit("setListActives", res.data.data);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Listar los banners activos.
 */
export async function getTotalBannersActives({ commit, state }) {
    commit("dashboard/load", true, { root: true });
    try {
        const res = await $http.get("/app-banners/total-actives");
        commit("setTotalActives", res.data.data);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        commit("dashboard/load", false, { root: true });
    }
}
